import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-24 min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
        <p className="text-8xl md:text-9xl font-heading font-bold text-foreground-200 mb-4">404</p>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-2">页面未找到</h1>
        <p className="text-foreground-500 mb-8 max-w-md">您访问的页面不存在或已被移除，请检查网址是否正确。</p>
        <Link
          to="/"
          className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
        >
          返回首页
        </Link>
      </main>
      <Footer />
    </>
  );
}